var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38864 9.76456C6.34291 6.93865 9.06033 4.90911 12.279 4.90911C14.0093 4.90911 15.5721 5.50911 16.8 6.49093L20.3721 3.00001C18.1953 1.14546 15.4046 0 12.279 0C7.43911 0 3.27209 2.69831 1.2688 6.65004L5.38864 9.76456Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4138 18.0124C15.2986 18.7161 13.8816 19.0907 12.2791 19.0907C9.07267 19.0907 6.36374 17.0767 5.39969 14.2677L1.26624 17.3348C3.26703 21.2935 7.43395 23.9999 12.2791 23.9999C15.2801 23.9999 18.1478 22.9572 20.2954 20.9994L16.4138 18.0124Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2953 20.9994C22.5413 18.9519 23.9999 15.9035 23.9999 11.9998C23.9999 11.2907 23.8882 10.5271 23.7208 9.81799H12.2789V14.4544H18.865C18.54 16.0135 17.6677 17.221 16.4136 18.0124L20.2953 20.9994Z",
    fill: "#4A90E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3997 14.268C5.15549 13.5565 5.02325 12.7939 5.02325 12.0001C5.02325 11.2184 5.15151 10.4669 5.38867 9.76466L1.26883 6.65015C0.44674 8.26056 0 10.0755 0 12.0001C0 13.9197 0.455124 15.7303 1.26624 17.3351L5.3997 14.268Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.a1c6024e9ded41e57b60c1c7f51e3be0.svg";
export { ForwardRef as ReactComponent };